import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getEndorsementPath,
  getTravellerDetailsPath,
  getTripDetailsPath,
} from "./allPolicyConstants";
import { allPolicyTableBase, travellerTableBase } from "./policyTableConfig";
import { buildTripTableFields } from "./tripTableColumns";
import { buildTravellerTableFields } from "./travellerTableColumns";

export const useAllPolicyTableConfigs = (handlers, pathOverrides = {}) => {
  const roles = useSelector((state) => state.auth?.role || []);
  const {
    handleCoversExport,
    handleTripsExport,
    handleResendDoc,
    handleTripRowClick,
    handleTravellerRowClick,
  } = handlers;

  const tripDetailsPath = pathOverrides.tripDetails ?? getTripDetailsPath;
  const travellerDetailsPath = pathOverrides.travellerDetails ?? getTravellerDetailsPath;
  const endorsementPath = pathOverrides.endorsement ?? getEndorsementPath;
  const tripFields = useMemo(() => buildTripTableFields(roles), [roles]);

  const tripConfig = useMemo(
    () => ({
      ...allPolicyTableBase,
      fields: tripFields,
      actions: [{ label: "Details", to: tripDetailsPath, isButton: true }],
      handler: [
        { label: "Export", handler: handleTripsExport },
        { label: "Export Cover", handler: handleCoversExport },
      ],
      selectionCheckbox: true,
      onRowClick: handleTripRowClick,
      doubleClickRow: true,
    }),
    [handleCoversExport, handleTripsExport, handleTripRowClick, tripDetailsPath, tripFields]
  );

  const travellersConfig = useMemo(
    () => ({
      ...travellerTableBase,
      fields: buildTravellerTableFields(),
      handler: [{ label: "Resend", handler: handleResendDoc }],
      actions: [
        { label: "Details", to: travellerDetailsPath, isButton: true },
        { label: "Endorsement", to: endorsementPath },
      ],
      selectionCheckbox: true,
      onRowClick: handleTravellerRowClick,
      doubleClickRow: true,
    }),
    [handleResendDoc, handleTravellerRowClick, travellerDetailsPath, endorsementPath]
  );

  return { tripConfig, travellersConfig };
};
